module.exports = __webpack_public_path__ + "img/productpage_icon_messanger.1b99659f.png";